export const isUserAssetAdmin = (adminRoles) => {
    const ASSETADMIN = 'assetAdmin';
    return adminRoles.includes(ASSETADMIN);
};

export const isUserCustomerAdmin = (adminRoles) => {
    const CUSTOMERADMIN = 'customerAdmin';
    return adminRoles.includes(CUSTOMERADMIN);
};

/**
 * Returns a number that controls the range of functions within the app
 * 1 = user is administrator (grant)
 * 2 = user is editor (edit)
 * 3 = user is viewer (view), also when the selected logbook grants nothing
 * A customerAdmin counts as administrator on every logbook of their own customer,
 * matching what the backend already grants them via the x-customer-super header.
 * Must be derived during render from the currently selected logbook: a value kept in a ref
 * and updated in an effect reaches the pages one render late, and can stay stale.
 * @param {Array} accessArray, about the selected logbook access
 * @param {Boolean} isAdminSite, define where the user is
 * @param {Array} adminRoles, of the logged in user
 * @returns {Number} the access level
 */
export const getUserAccess = (accessArray, isAdminSite, adminRoles) => {
    if (isAdminSite || isUserCustomerAdmin(adminRoles ?? []) || accessArray?.includes('grant')) {
        return 1;
    }
    if (accessArray?.includes('edit')) {
        return 2;
    }
    return 3;
};
